export class FormConfig {
    /**
     * 是否是添加
     */
    add?: boolean;
    /**
     * 是否是修改
     */
    update?: boolean;
    /**
     * 表单标题
     */
    formTitle?: string;
    [key: string]: any;
    items?: {
        [key: string]: any;
    };
    /**
     * 表单label文字描述
     */
    title?: string;
    /**
     * 后端的入参字段名称
     */
    name?: string;
    /**
     * 是否显示表单项
     */
    show?: boolean;
    /**
     * 是否可编辑
     */
    isEdit?: boolean;
    /**
     * 组件配置
     */
    ui?: {
        type?: string,
        colSpan?: number,
        data?: any[],
        showTime?: boolean,
        isMoreCurrent?: boolean,
        url?: string,
        params?: object,
        name?: string,
        value?: string,
        disabled?: boolean,
        mode?: string,
        loading?: boolean,
        selectedValue?: null,
        showToday?: boolean,
        modelChange?: any;
    };
    /**
     * 数据类型
     */
    type?: string;
    /**
     * 数据格式化,内置phone,email,card
     */
    format?: string;
    /**
     * 正则表达式
     */
    patten?: string;
    /**
     * 数字最大值
     */
    maxmun?: string;
    /**
     * 数字最小值
     */
    minmun?: string;
    /**
     * 字符最大长度
     */
    maxLegth?: number;
    /**
     * 字符最小长度
     */
    minLegth?: number;
    /**
     * 是否必填
     */
    isRequire?: boolean;
    /**
     * 错误信息提示
     */
    errorMessage?: string;
    /**
     * 表单项的值
     */
    value?: any;
    /**
     * 表单组
     */
    formGroup?: any;
    /**
     * ui自定义事件
     */
    modelChange?: any;
    /**
     * 所有表单统一占8格
     */
    colSpan?: number;
    /**
     * 文件列表
     */
    fileList?: Array<any>;
    /**
     * 提交路径
     */
    submitUrl?: string;
    /**
     * 提交方式
     */
    submitType?: string;
    /**
     * 一部分静态数据（动态数据中的静态配置项）
     */
    staticConfig?: object;
    constructor() {
        this.add = false;
        this.update = false;
        this.show = false;
        this.isEdit = true;
        this.colSpan = 8;
        this.submitUrl = '';
        this.submitType = 'put';
        // this.isRequire = false;
        // this.errorMessage = '信息填写错误';
    }
}
